export const carouselTypes = {
  PLA: 'pla',
  SEO: 'seo'
};

export const BANNER = 'banner';
export const PRODUCT = 'product';

export const bannerTypes = {
  HERO: 'hero',
  LEADERBOARD: 'leaderboard',
  MIDDLE: 'middle', // pip
  SKYSCRAPER: 'skyscraper'
};
